import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getAccessToken } from 'src/utils/sse.utils';

const Main = () => {
  const access = getAccessToken();
  const location = useLocation();
  const redirect = access ? '/dashboard' : '/auth';

  return <Navigate to={redirect} state={{ from: location }} replace />;
};

export default Main;
